import Component from './message_template_table.vue'
export default Component
